/* eslint-disable prefer-const */
import _ from 'lodash';
import { WoodOutlined } from './ModelElements/WoodOutlined';
import { Insulation } from './ModelElements/Insulation';
import { LamellaBase } from './ModelElements/LamellaBase';
import { LamellaReady } from './ModelElements/LamellaReady';

import FiberText from './FiberText/FiberText';

function createLamellaData(Component, order, orientation, index, key, width = null, offset = null) {
  const scale = width ? [order.lamellaWidth / 200, order.lamellaThickness / 100, width / 200] : [order.lamellaWidth / 200, order.lamellaThickness / 100, order.lamellaLength / 200];

  const position = offset
    ? [orientation === 5 ? 0 : index * (order.lamellaWidth / 200) * 2 - (order.lamellaWidth / 200) * (order.numOfLamellas - 1), 2, offset / 100 + width / 200 - order.lamellaLength / 200]
    : [
        orientation === 4 ? 0 : index * (order.lamellaWidth / 200) * 2 - (order.lamellaWidth / 200) * (order.numOfLamellas - 1),
        2,
        orientation === 1 ? 0 : index * (order.lamellaWidth / 200) * 2 - (order.lamellaWidth / 200) * (order.numOfLamellas - 1)
      ];

  const rotation = orientation === 4 ? Math.PI / 2 : 0;

  return {
    component: Component,
    scale,
    position,
    rotation,
    key
  };
}

export default function getCLTOrderLayerModel(order, layer, id, suppressLabels = false) {
  const lamellas = [];
  const layerId = _.get(id, -1);

  if (layer) {
    const orientation = parseInt(layer.orientation);

    const isFullWoodLayer = Number(layer.orientation) === 1 || Number(layer.orientation) === 2;

    const transparentCover = order?.clever && isFullWoodLayer;

    const woodProps = transparentCover ? { transparent: true, opacity: 0.6 } : {};

    if (orientation === 7 || orientation === 8) {
      addCleverGrid(lamellas, layer, 2, `clever-layer-${layer.id || 0}`, order);
      return lamellas;
    }

    let sequenceLam = [];
    layer.orientation === 6 ? (sequenceLam = calculateLengthOffsetSequence(layer)) : (sequenceLam = calculateWidthOffsetSequence(layer));

    for (let i = 0; i < (sequenceLam.length || layer.numOfLamellas); i++) {
      let orientation = parseInt(layer.orientation);
      // console.log(`Processing lamella ${i} with orientation ${orientation}`);

      switch (orientation) {
        case 4:
          if (sequenceLam[i]) {
            lamellas.push(createLamellaData(WoodOutlined, layer, orientation, i, `lamella-${i}`));
          } else {
            lamellas.push(createLamellaData(Insulation, layer, orientation, i, `insulation-${i}`));
          }
          break;
        case 5:
          if (sequenceLam[i]) {
            lamellas.push({
              component: WoodOutlined,
              scale: [layer.lamellaWidth / 200, layer.lamellaThickness / 100, layer.lamellaLength / 200],
              position: [
                orientation === 2 ? 0 : i * (layer.lamellaWidth / 200) * 2 - (layer.lamellaWidth / 200) * (layer.numOfLamellas - 1),
                2,
                orientation === 5 ? 0 : i * (layer.lamellaWidth / 200) * 2 - (layer.lamellaWidth / 200) * (layer.numOfLamellas - 1)
              ],
              rotation: orientation === 2 ? Math.PI / 2 : 0,
              key: `lamella-${i}`
            });
          } else {
            lamellas.push({
              component: Insulation,
              scale: [layer.lamellaWidth / 200, layer.lamellaThickness / 100, layer.lamellaLength / 200],
              position: [
                orientation === 2 ? 0 : i * (layer.lamellaWidth / 200) * 2 - (layer.lamellaWidth / 200) * (layer.numOfLamellas - 1),
                2,
                orientation === 5 ? 0 : i * (layer.lamellaWidth / 200) * 2 - (layer.lamellaWidth / 200) * (layer.numOfLamellas - 1)
              ],
              rotation: orientation === 2 ? Math.PI / 2 : 0,
              key: `insulation-${i}`
            });
          }
          break;
        case 6:
          if (sequenceLam[i]) {
            lamellas.push({
              component: WoodOutlined,
              scale: [layer.lamellaWidth / 200, layer.lamellaThickness / 100, layer.lamellaLength / 200],
              position: [
                layer.orientation === 2 ? 0 : i * (layer.lamellaWidth / 200) * 2 - (layer.lamellaWidth / 200) * (layer.numOfLamellas - 1),
                2,
                layer.orientation === 6 ? 0 : i * (layer.lamellaWidth / 200) * 2 - (layer.lamellaWidth / 200) * (layer.numOfLamellas - 1)
              ],
              rotation: orientation === 2 ? Math.PI / 2 : 0,
              key: `lamella-${i}`
            });
          } else {
            if (layer?.lengthoffset != undefined)
              for (let m = 0; m < layer.lengthoffset.length; m++) {
                lamellas.push({
                  component: WoodOutlined,
                  scale: [layer.lamellaWidth / 200, layer.lamellaThickness / 100, layer.lengthoffset[m].width / 200],
                  position: [
                    layer.orientation === 5 ? 0 : i * (layer.lamellaWidth / 200) * 2 - (layer.lamellaWidth / 200) * (layer.numOfLamellas - 1),
                    2,
                    layer.lengthoffset[m].offset / 100 + layer.lengthoffset[m].width / 200 - layer.lamellaLength / 200
                  ],
                  rotation: orientation === 5 ? Math.PI / 2 : 0,
                  key: `lamella-${i}-${m}`
                });
              }
          }
          break;

        case 7:
        case 8: {
          addCleverGrid(lamellas, olayer, j * 2, `clever-order-${j}`, order);
          break;
        }
        default:
          lamellas.push({
            component: WoodOutlined,
            scale: [layer.lamellaWidth / 200, layer.lamellaThickness / 100, layer.lamellaLength / 200],
            position: [
              orientation === 2 ? 0 : i * (layer.lamellaWidth / 200) * 2 - (layer.lamellaWidth / 200) * (layer.numOfLamellas - 1),
              2,
              orientation === 1 ? 0 : i * (layer.lamellaWidth / 200) * 2 - (layer.lamellaWidth / 200) * (layer.numOfLamellas - 1)
            ],
            rotation: orientation === 2 ? Math.PI / 2 : 0,
            key: `lamella-${i}`,
            ...woodProps
          });
      }
      {
        /* Test progression of layer production numDOne dynamically */
      }
      // console.log('LAyer lamellaArray: ', layer.lamellaArray);
      // if (!lamelalArray[i].present) {
      //   lamellas[i].component = LamellaBase;
      // }
      // lamellas.push({
      //   component: TextInfo,
      //   position: [-50, 10, 100], // Adjust this position as needed to place in the top left corner
      //   children: getLayerOrientation(layer),
      //   size: 50,
      //   key: `text-${i}`
      // });
    }
  } else {
    // console.log('ORDER: ');
    if (order?.layers !== undefined) {
      order.layers.forEach((olayer, j) => {
        const isFullWoodLayer = Number(olayer.orientation) === 1 || Number(olayer.orientation) === 2;

        const isOuterCapLayer = j === 0 || j === order.layers.length - 1;
        const transparentCover = order?.clever && isFullWoodLayer && isOuterCapLayer;
        console.log('TRANSPARENT CHECK', j, olayer.orientation, transparentCover);
        const woodProps = transparentCover ? { transparent: true, opacity: 0.2 } : {};

        let sequenceLam = olayer.orientation === 6 ? calculateLengthOffsetSequence(olayer) : calculateWidthOffsetSequence(olayer);
        // if (j > 0) return;
        for (let i = 0; i < (sequenceLam.length || olayer.numOfLamellas); i++) {
          const position = [
            olayer.orientation === 2 ? 0 : i * (olayer.lamellaWidth / 200) * 2 - (olayer.lamellaWidth / 200) * (olayer.numOfLamellas - 1),
            j * 2,
            olayer.orientation === 1 ? 0 : i * (olayer.lamellaWidth / 200) * 2 - (olayer.lamellaWidth / 200) * (olayer.numOfLamellas - 1)
          ];
          const rotation = olayer.orientation === 2 ? Math.PI / 2 : 0;

          if (olayer.id === layerId) {
            lamellas.push({
              component: WoodOutlined,
              scale: [olayer.lamellaWidth / 200, olayer.lamellaThickness / 100, olayer.lamellaLength / 200],
              position,
              rotation,
              key: `colored-lamella-${j}-${i}`,
              ...woodProps
            });
          } else {
            const orientate = parseInt(olayer.orientation);
            switch (orientate) {
              case 4:
                if (sequenceLam[i]) {
                  lamellas.push({
                    component: WoodOutlined,
                    scale: [olayer.lamellaWidth / 200, olayer.lamellaThickness / 100, olayer.lamellaLength / 200],
                    position: [
                      orientate === 4 ? 0 : i * (olayer.lamellaWidth / 200) * 2 - (olayer.lamellaWidth / 200) * (olayer.numOfLamellas - 1),
                      j * 2,
                      orientate === 1 ? 0 : i * (olayer.lamellaWidth / 200) * 2 - (olayer.lamellaWidth / 200) * (olayer.numOfLamellas - 1)
                    ],
                    rotation: orientate === 4 ? Math.PI / 2 : 0,
                    key: `lamella-${j}-${i}`
                  });
                } else {
                  lamellas.push({
                    component: Insulation,
                    scale: [olayer.lamellaWidth / 200, olayer.lamellaThickness / 100, olayer.lamellaLength / 200],
                    position: [
                      orientate === 4 ? 0 : i * (olayer.lamellaWidth / 200) * 2 - (olayer.lamellaWidth / 200) * (olayer.numOfLamellas - 1),
                      j * 2,
                      orientate === 1 ? 0 : i * (olayer.lamellaWidth / 200) * 2 - (olayer.lamellaWidth / 200) * (olayer.numOfLamellas - 1)
                    ],
                    rotation: orientate === 4 ? Math.PI / 2 : 0,
                    key: `insulation-${j}-${i}`
                  });
                }
                break;
              case 5:
                if (sequenceLam[i]) {
                  lamellas.push({
                    component: WoodOutlined,
                    scale: [olayer.lamellaWidth / 200, olayer.lamellaThickness / 100, olayer.lamellaLength / 200],
                    position: [
                      orientate === 2 ? 0 : i * (olayer.lamellaWidth / 200) * 2 - (olayer.lamellaWidth / 200) * ((sequenceLam.length || olayer.numOfLamellas) - 1),
                      j * 2,
                      orientate === 5 ? 0 : i * (olayer.lamellaWidth / 200) * 2 - (olayer.lamellaWidth / 200) * (olayer.numOfLamellas - 1)
                    ],
                    rotation: orientate === 2 ? Math.PI / 2 : 0,
                    key: `lamella-${j}-${i}`
                  });
                } else {
                  lamellas.push({
                    component: Insulation,
                    scale: [olayer.lamellaWidth / 200, olayer.lamellaThickness / 100, olayer.lamellaLength / 200],
                    position: [
                      orientate === 2 ? 0 : i * (olayer.lamellaWidth / 200) * 2 - (olayer.lamellaWidth / 200) * ((sequenceLam.length || olayer.numOfLamellas) - 1),
                      j * 2,
                      orientate === 5 ? 0 : i * (olayer.lamellaWidth / 200) * 2 - (olayer.lamellaWidth / 200) * (olayer.numOfLamellas - 1)
                    ],
                    rotation: orientate === 2 ? Math.PI / 2 : 0,
                    key: `insulation-${j}-${i}`
                  });
                }
                break;
              case 6:
                if (sequenceLam[i]) {
                  lamellas.push({
                    component: WoodOutlined,
                    scale: [olayer.lamellaWidth / 200, olayer.lamellaThickness / 100, olayer.lamellaLength / 200],
                    position: [
                      olayer.orientation === 2 ? 0 : i * (olayer.lamellaWidth / 200) * 2 - (olayer.lamellaWidth / 200) * (olayer.numOfLamellas - 1),
                      j * 2,
                      olayer.orientation === 6 ? 0 : i * (olayer.lamellaWidth / 200) * 2 - (olayer.lamellaWidth / 200) * (olayer.numOfLamellas - 1)
                    ],
                    rotation: orientate === 2 ? Math.PI / 2 : 0,
                    key: `lamella-${j}-${i}`
                  });
                } else {
                  if (olayer?.lengthoffset != undefined)
                    for (let m = 0; m < olayer.lengthoffset.length; m++) {
                      lamellas.push({
                        component: WoodOutlined,
                        scale: [olayer.lamellaWidth / 200, olayer.lamellaThickness / 100, olayer.lengthoffset[m].width / 200],
                        position: [
                          olayer.orientation === 5 ? 0 : i * (olayer.lamellaWidth / 200) * 2 - (olayer.lamellaWidth / 200) * (olayer.numOfLamellas - 1),
                          j * 2,
                          olayer.lengthoffset[m].offset / 100 + olayer.lengthoffset[m].width / 200 - olayer.lamellaLength / 200
                        ],
                        rotation: orientate === 5 ? Math.PI / 2 : 0,
                        key: `lamella-${j}-${i}-${m}`
                      });
                    }
                }
                break;
              case 7:
              case 8: {
                addCleverGrid(lamellas, olayer, j * 2, `clever-order-${j}`);
                break;
              }
              default:
                lamellas.push({
                  component: WoodOutlined,
                  scale: [olayer.lamellaWidth / 200, olayer.lamellaThickness / 100, olayer.lamellaLength / 200],
                  position: [
                    orientate === 2 ? 0 : i * (olayer.lamellaWidth / 200) * 2 - (olayer.lamellaWidth / 200) * (olayer.numOfLamellas - 1),
                    j * 2,
                    orientate === 1 ? 0 : i * (olayer.lamellaWidth / 200) * 2 - (olayer.lamellaWidth / 200) * (olayer.numOfLamellas - 1)
                  ],
                  rotation: orientate === 2 ? Math.PI / 2 : 0,
                  key: `lamella-${j}-${i}`,
                  ...woodProps
                });
                if (order?.lamellaArray != undefined) {
                  // console.log('Order lamellas: ', lamellas[i], ' for i: ', i);
                  // console.log('Order lamellaArray: ', order?.lamellaArray[i]);

                  if (!order.lamellaArray[i].present) {
                    lamellas[i].component = LamellaBase;
                  }
                  if (order.lamellaArray[i].loaded) {
                    lamellas[i].component = LamellaReady;
                  }
                }
            }
          }
        }

        if (!suppressLabels) {
          lamellas.push({
            component: FiberText,
            position: getLayerPosition(olayer, j),
            children: getText(olayer.orientation),
            size: 10,
            key: `text-${j}`
          });
        }
      });
    }
  }

  return lamellas;
}

function calculateWidthOffsetSequence(l) {
  if (l !== null) {
    let lamellas = [];
    let lastOffset = 0;
    if (l.widthoffset != undefined) {
      const numericWidthoffset = l.widthoffset.map((item) => {
        return {
          ...item,
          offset: Number(item.offset),
          width: Number(item.width)
        };
      });

      const sortedWidthOffset = numericWidthoffset.sort((a, b) => a.offset - b.offset);

      if (sortedWidthOffset.length > 0 && l.lamellaWidth > 0) {
        for (let i = 0; i < sortedWidthOffset.length; i++) {
          let ins = sortedWidthOffset[i];
          let woodWidth = ins.offset - lastOffset;
          let woodLamellas = Math.round(woodWidth / l.lamellaWidth);
          let widthoffsetLamellas = Math.round(ins.width / l.lamellaWidth);

          lastOffset = ins.offset + ins.width;
          for (let j = 0; j < woodLamellas; j++) lamellas.push(true);
          for (let j = 0; j < widthoffsetLamellas; j++) lamellas.push(false);
        }
      }
    }

    if (l.lamellaWidth > 0) {
      let endDimension = l.orientation === 4 || l.orientation === 2 ? l.panelLength : l.panelWidth;
      let woodLamellas = Math.round((endDimension - lastOffset) / l.lamellaWidth);
      for (let j = 0; j < woodLamellas; j++) lamellas.push(true);
    }

    return lamellas;
  }
}

function calculateLengthOffsetSequence(l) {
  if (l !== null) {
    let lamellas = [];
    let lastOffset = 0;
    if (l.widthoffset != undefined) {
      const numericWidthoffset = l.widthoffset.map((item) => {
        return {
          ...item,
          offset: Number(item.offset),
          width: Number(item.width)
        };
      });

      const sortedWidthOffset = numericWidthoffset.sort((a, b) => a.offset - b.offset);

      if (sortedWidthOffset.length > 0 && l.lengthoffsetWidth > 0) {
        for (let i = 0; i < sortedWidthOffset.length; i++) {
          let ins = sortedWidthOffset[i];
          let woodWidth = ins.offset - lastOffset;
          let woodLamellas = Math.round(woodWidth / l.lengthoffsetWidth);
          let widthoffsetLamellas = Math.round(ins.width / l.lengthoffsetWidth);

          lastOffset = ins.offset + ins.width;
          for (let j = 0; j < woodLamellas; j++) lamellas.push(true);
          for (let j = 0; j < widthoffsetLamellas; j++) lamellas.push(false);
        }
      }
    }

    if (l.lamellaWidth > 0) {
      let endDimension = l.orientation === 4 || l.orientation === 2 ? l.panelLength : l.panelWidth;
      let woodLamellas = Math.round((endDimension - lastOffset) / l.lamellaWidth);
      for (let j = 0; j < woodLamellas; j++) lamellas.push(true);
    }

    return lamellas;
  }
}

function getLayerPosition(olayer, j) {
  let position = [];
  switch (parseInt(olayer.orientation)) {
    case 1:
      position.push(
        olayer.numOfLamellas * (olayer.lamellaWidth / 200) * 2 - (olayer.lamellaWidth / 200) * (olayer.numOfLamellas - 1),
        j * 2,
        olayer.numOfLamellas * (olayer.lamellaWidth / 200) - (olayer.lamellaWidth / 200) * (olayer.numOfLamellas - 1) + olayer.lamellaLength / 200
      );
      break;
    case 2:
      position.push(
        olayer.numOfLamellas * (olayer.lamellaWidth / 200) - (olayer.lamellaWidth / 200) * (olayer.numOfLamellas - 1) + olayer.lamellaLength / 200,
        j * 2,
        olayer.numOfLamellas * (olayer.lamellaWidth / 200) * 2 - (olayer.lamellaWidth / 200) * (olayer.numOfLamellas - 1)
      );
      break;
    case 4:
      position.push(
        olayer.numOfLamellas * (olayer.lamellaWidth / 200) - (olayer.lamellaWidth / 200) * (olayer.numOfLamellas - 1) + olayer.lamellaLength / 200,
        j * 2,
        olayer.numOfLamellas * (olayer.lamellaWidth / 200) * 2 - (olayer.lamellaWidth / 200) * (olayer.numOfLamellas - 1)
      );
      break;
    case 5:
      position.push(
        olayer.numOfLamellas * (olayer.lamellaWidth / 200) * 2 - (olayer.lamellaWidth / 200) * (olayer.numOfLamellas - 1),
        j * 2,
        olayer.numOfLamellas * (olayer.lamellaWidth / 200) - (olayer.lamellaWidth / 200) * (olayer.numOfLamellas - 1) + olayer.lamellaLength / 200
      );
      break;
    case 6:
      position.push(
        olayer.numOfLamellas * (olayer.lamellaWidth / 200) * 2 - (olayer.lamellaWidth / 200) * (olayer.numOfLamellas - 1),
        j * 2,
        olayer.numOfLamellas * (olayer.lamellaWidth / 200) - (olayer.lamellaWidth / 200) * (olayer.numOfLamellas - 1) + olayer.lamellaLength / 200
      );
      break;
    case 7:
      position.push(
        olayer.numOfLamellas * (olayer.lamellaWidth / 200) * 2 - (olayer.lamellaWidth / 200) * (olayer.numOfLamellas - 1),
        j * 2,
        olayer.numOfLamellas * (olayer.lamellaWidth / 200) - (olayer.lamellaWidth / 200) * (olayer.numOfLamellas - 1) + olayer.lamellaLength / 200
      );
      break;
    case 8:
      position.push(
        olayer.numOfLamellas * (olayer.lamellaWidth / 200) * 2 - (olayer.lamellaWidth / 200) * (olayer.numOfLamellas - 1),
        j * 2,
        olayer.numOfLamellas * (olayer.lamellaWidth / 200) - (olayer.lamellaWidth / 200) * (olayer.numOfLamellas - 1) + olayer.lamellaLength / 200
      );
      break;
    default:
      console.log('ERROR: getLayerPosition: Unknown orientation');
      break;
  }

  return position;
}

function getText(orientation) {
  switch (parseInt(orientation)) {
    case 1:
      return 'L';
    case 2:
      return 'C';
    case 4:
      return 'C TH';
    case 5:
      return 'L TH';
    case 6:
      return 'M';
    case 7:
      return 'C Q';
    case 8:
      return 'C L';
    default:
      return '';
  }
}

function addCleverGrid(lamellas, olayer, y, keyPrefix, order = null) {
  const isCQ = Number(olayer.orientation) === 7;
  const isCL = Number(olayer.orientation) === 8;

  const panelLength = Number(order?.panelLength || olayer.panelLength || olayer.layerLength || olayer.lamellaLength || 0);
  const panelWidth = Number(order?.panelWidth || olayer.panelWidth || olayer.layerWidth || 0);
  const thickness = Number(olayer.lamellaThickness || olayer.rawThickness || 40);

  if (!panelLength || !panelWidth) return;

  const lengthOffsets = Array.isArray(olayer.lengthoffset) ? olayer.lengthoffset : [];
  const widthOffsets = Array.isArray(olayer.widthoffset) ? olayer.widthoffset : [];

  const pushPiece = (scaleX, scaleZ, posX, posZ, key, top = false) => {
    lamellas.push({
      component: WoodOutlined,
      scale: [scaleZ, thickness / 100, scaleX],

      position: [posZ, y + (top ? 0.06 : 0), posX],
      rotation: 0,
      key
    });
  };

  lengthOffsets
    .map((o) => ({ offset: Number(o.offset || 0), width: Number(o.width || 0) }))
    .filter((o) => o.width > 0)
    .sort((a, b) => a.offset - b.offset)
    .forEach((p, m) => {
      pushPiece(p.width / 200, panelWidth / 200, p.offset / 100 + p.width / 200 - panelLength / 200, 0, `${keyPrefix}-ll-${m}`, Number(olayer.orientation) === 8);
    });

  widthOffsets
    .map((o) => ({ offset: Number(o.offset || 0), width: Number(o.width || 0) }))
    .filter((o) => o.width > 0)
    .sort((a, b) => a.offset - b.offset)
    .forEach((p, m) => {
      pushPiece(panelLength / 200, p.width / 200, 0, p.offset / 100 + p.width / 200 - panelWidth / 200, `${keyPrefix}-cl-${m}`, Number(olayer.orientation) === 7);
    });
}

// function getLayerOrientation(child) {
//   switch (parseInt(child.orientation)) {
//     case 1:
//       return 'Long';
//     case 2:
//       return 'Cross';
//     case 4:
//       return 'Cross Thermo';
//     case 5:
//       return 'Long Thermo';
//     case 6:
//       return 'Multipiece';

//     default:
//       return 'null'; // or some default value
//   }
// }
